import { Dispatch } from "redux";
import { Element } from "../models/elementModel";
import { Prototype } from "../models/prototypeModel";
import { AppState } from "../reducers/rootReducer";
import { AppActions, EDIT_PROTOTYPE, SET_PROTOTYPE } from "../types/actions";
import { addElements, editElement } from "./elementListAction";
import { addRows } from "./rowListAction";
import { addSections } from "./sectionListAction";
import { addTabs } from "./tabListAction";

export const setProtoType = (protoType:Prototype) : AppActions => ({
    type: SET_PROTOTYPE,
    protoType
});

export const editProtoType = (protoType: Prototype) : AppActions => ({
    type: EDIT_PROTOTYPE,
    protoType
});

// start editing protoype variables 

export const startEditProtoType = (protoType: Prototype) => {
    return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        dispatch(editProtoType(protoType));
    };
};

// start set all session data 

export const startSetProtoType = (protoType: Prototype) => {
    return( dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        dispatch(setProtoType(protoType));
    }
}

export const startAddFormDetailsbyIdRedux = (data : any) => {
    return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        dispatch(addRows(data.data.rowList));
          dispatch(addSections(data.data.sectionList))
          dispatch(addElements(data.data.elementList));
          dispatch(addTabs(data.data.tabList))
    };
};

export const startEditElementPreviewAndPrototype = (element: Element) => {
    return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        dispatch(editElement(element));
    };
};
